import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { RouterModule } from "@angular/router";

import { InvestmentCompanyListComponent } from "./components/investment-company-list/investment-company-list.components";
import { InvestmentCompanyDetailComponent } from "./components/investment-company-detail/investment-company-detail.component";
import { InvestmentCompanyFormDialogComponent } from "./components/investment-company-form-dialog/investment-company-form-dialog.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
  declarations: [
    InvestmentCompanyListComponent,
    InvestmentCompanyDetailComponent,
    InvestmentCompanyFormDialogComponent,
  ],
  exports: [
    InvestmentCompanyListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    RouterModule,
    FormsModule,
    SharedModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatDatepickerModule,
    MatSlideToggleModule,
  ],
})
export class InvestmentCompanyModule { }
